import http from './axios';

export interface IndicatorDto {
  id?: number;
  // 指标编码
  indCode?: string;
  parentIndCode?: string;
  // 指标名称
  indName?: string;
  // 常用名称
  indOrdinaryName?: string;
  // 指标大类 字典表
  indFirstLevel?: string;
  // 指标中类 字典表
  indSecondLevel?: string;
  // 指标小类 字典表
  indThirdLevel?: string;
  // 指标维度 字典表
  indDimention?: number;
  // 指标集编码
  indSetCode?: string;
  // 指标目录
  indCategoryId?: number;
  // 指标排序
  indSort?: string;
  // 计量类型 字典表
  indMearsureType?: number;
  // 计量单位 字典表
  indMearsureUnit?: number;
  // 数据类型 字典表
  indDataType?: number;
  // 指标类型
  indType?: number | string;
  // 数据格式 字典表
  indDataFormat?: number;
  // 指标分层 字典表
  indLevel?: number;
  // 指标重要性 字典表
  indImportance?: number;
  // 易出问题率 字典表
  indIssueRate?: number;
  // 管理板块
  indOwnerPlate?: string;
  // 管理部门ID
  indOwnerDept?: string;
  // 指标负责人ID
  indOwnerUid?: string;
  indOwnerName?: string;
  // 指标描述
  indDescription?: string;
  // 指标标签
  indLabel?: string;
  // 指标值变化度量类型 字典表
  indChangeMeasureType?: number;
  // 作业运行方式 0-手动，1-定时，2-周期
  jobMode?: number;
  // 作业运行配置
  // cron表达式
  cronExpression?: string;
  // 使用状态 0：启用，1：禁用
  status?: number;
  // 重点监控指标 0：否，1：是
  isImportant?: number;
  // 指标定义
  indDefinition?: any;
  indCompose?: any;
  // 指标值变化一级预警设置 JSON格式
  indChangeAlertSetting?: AlertSetting;
  // 作业运行配置
  jobConfig?: any;
  approveStatus?: number;
}

export interface AlertSetting {
  chgAlertMode: number;
  chgAlertSettings: {
    alertEvent: number | string;
    alertLevel: number | string;
    intervalVal1: number;
    intervalVal2: number;
  }[];
}

export default class IndicatorServices {
  private readonly tree_api = '/v1/indicatordef/tree';
  private readonly list_api = '/v1/indicatordef/list';
  private readonly info_api = '/v1/indicatordef/info';
  private readonly save_api = '/v1/indicatordef/save';
  private readonly update_api = '/v1/indicatordef/update';
  private readonly remove_api = '/v1/indicatordef/delete';
  private readonly dimData_api = '/v1/indicatordef/dim-data';

  constructor() {}

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getEnableList(params?: object): Promise<any> {
    // 0-新建待提交，1-编辑待提交，2-新建已提交，3-编辑已提交，4-新建已审批，5-编辑已审批，6-新建已驳回，7-编辑已驳回
    return await this.getList({ ...params, status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
  }

  async getTree(params?: object): Promise<any> {
    let res: any = await http.get(this.tree_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async add(data: IndicatorDto) {
    const params = { ...data, indSort: '1', indCode: 'IND_' + data.indCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: IndicatorDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  async getDimData(params?: object) {
    let res: any = await http.get(this.dimData_api, { params: params });
    return res.payload;
  }
}
